import type {
  RepeatableShiftOptions,
  Shift,
  ShiftOptions,
  TeamMemberDto,
} from '@api'

import type { Creator } from '../creators/types'
import type { weekdays } from '../tasks/service/repeatable-task-service'

export interface BaseDialogProps {
  isModalVisible: boolean
  onClose: () => void
  creators: Creator[]
}

export type CreateShiftDialogProps = BaseDialogProps

export interface EditShiftDialogProps extends BaseDialogProps {
  shift: Shift
  repeatDays: (typeof weekdays)[number][]
}

export const getUniqueShiftKey = (shift: Shift) => {
  return shift.id ? shift.id : `${shift.repeatableShiftId}-${shift.startedAt}`
}

export type ShiftGroupsMapByCreators = Record<Creator['id'], Shift[]>

export interface GetShiftsListResponse {
  shifts: ShiftGroupsMapByCreators
}

export type GetShiftHistoryResponse = Array<{
  shift: Shift
  tracking: ShiftTracking[]
}>

export type NormalizedShiftMutationOptions =
  | {
      isRepeatable: true
      data: RepeatableShiftOptions
    }
  | {
      isRepeatable: false
      data: ShiftOptions
    }

export interface EditRepeatableShiftMutationOptions {
  data: RepeatableShiftOptions
  originalShift: Shift
  target: MutateRepeatableShiftTarget
}

export interface EditSingleShiftMutationOptions {
  data: ShiftOptions
  originalShift: Shift
}

export interface ShiftTracking {
  browserName: string
  grossSoldRevenue: number
  sendMessages: number
  sendMediaMessages: number
  boughtMediaMessages: number
  ppvPurchaseRate: number
  averageResponseTime: number
}

export interface ShiftHistory {
  shift: Shift
  tracking: ShiftTracking
}

export type MutateRepeatableShiftTarget = 'Shift' | 'All'

export interface DeleteShiftRequestOptions {
  shift: Shift
  target?: MutateRepeatableShiftTarget
}

export interface AccessibleTeamMembersResponse {
  members: Omit<TeamMemberDto, 'permissions'>[]
}
